'use client';

import { useCallback } from 'react';
import { useSite } from 'src/context/providers/SiteProvider';
import { DiscoveryListActionTypes } from 'src/context/reducers/actionTypes';

const useDiscoveryList = () => {
  const { state, dispatch } = useSite();
  const { sort, order, page, pageSize, q } = state.discoveryList;

  const setSort = useCallback(
    (newSort: string) => {
      dispatch({ type: DiscoveryListActionTypes.SET_SORT, payload: newSort });
    },
    [dispatch]
  );

  const setOrder = useCallback(
    (newOrder: 'asc' | 'desc') => {
      dispatch({ type: DiscoveryListActionTypes.SET_ORDER, payload: newOrder });
    },
    [dispatch]
  );

  const setPage = useCallback(
    (newPage: number) => {
      dispatch({ type: DiscoveryListActionTypes.SET_PAGE, payload: newPage });
    },
    [dispatch]
  );

  const setPageSize = useCallback(
    (newPageSize: number) => {
      dispatch({
        type: DiscoveryListActionTypes.SET_PAGE_SIZE,
        payload: newPageSize,
      });
    },
    [dispatch]
  );

  const setResultsSearch = useCallback(
    (search: string) => {
      dispatch({
        type: DiscoveryListActionTypes.SET_SEARCH,
        payload: search,
      });
    },
    [dispatch]
  );

  return {
    // State
    sort,
    order,
    page,
    pageSize,
    q,

    // Actions
    setSort,
    setOrder,
    setPage,
    setPageSize,
    setResultsSearch,
  };
};

export default useDiscoveryList;
